import { RenderSelectInput } from "app/common/renderInput";
import React from "react";
import MemberSearch from "../MemberSearch";

export default function Affiliate({
  values,
  setFieldValue,
  setState,
  errors,
  touched,
  state,
  handleChange,
  handleBlur,
}) {
  const affiliateService = [
    { value: 1, label: "Hotel Offline Ticket Booking" },
  ];
  return (
    <div>
      <div className="row">
        <div className="col-md-6 col-12">
          <label style={{ marginBottom: 20, fontWeight: "bold" }}>
            Name <span style={{ color: "red" }}>*</span>
          </label>

          <MemberSearch setFieldValue={setFieldValue} />
          {values.balance && (
            <div style={{ color: "red", fontWeight: "bold" }}>
              Wallet Balence : ₹ {Number(values.balance).toFixed(2)}
            </div>
          )}
          {touched.memId && errors.memId ? (
            <div className="error-label fw-bold fs-xs">{errors.memId}</div>
          ) : (
            ""
          )}
        </div>
        <div className="col-md-6 col-12">
          <label style={{ fontWeight: "bold" }}>
            Service <span style={{ color: "red" }}>*</span>
          </label>
          <span>
            <RenderSelectInput
              name="service"
              placeholder="Affiliate Service"
              value={values.service}
              items={affiliateService}
              error={errors.service}
              onChange={handleChange}
              onBlur={handleBlur}
              touched={touched.service}
            ></RenderSelectInput>
          </span>
        </div>
      </div>
    </div>
  );
}
